import * as actionTypes from "../actionTypes.js";

const initialState = {
  associatedCompanies: null,
  myProfile: null
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ASSOCIATED_COMPANIES:
      return { ...state, associatedCompanies: action.payload };
    case actionTypes.GET_MY_PROFILE:
      return { ...state, myProfile: action.payload };

    case actionTypes.LOG_OUT:
      return initialState;
    
    default:
      return state;
  }
};

export default profileReducer;